import { MailProtocolWizardActionTypes, MailProtocolWizardReduxState, SET_INITIAL_STATE, UPDATE_MAIL_PROTOCOL_WIZARD_STATE } from './types'

const initialState: MailProtocolWizardReduxState = {
    lateralPanelMailProtocolWizardIsOpen: false,
    selectedMailboxAddress: undefined,
    selectedMail: undefined,
    selectedDocument: undefined,
    fileListOptions: undefined
}

export function mailProtocolWizardReducer(state = initialState, action: MailProtocolWizardActionTypes): MailProtocolWizardReduxState {
    switch (action.type) {
        case SET_INITIAL_STATE: {
            return {
                ...initialState
            }
        }
        case UPDATE_MAIL_PROTOCOL_WIZARD_STATE: {
            return {
                ...state,
                ...action.payload
            }
        }

        default:
            return state
    }
}